import { NavigateFunction, SetURLSearchParams } from "react-router-dom";
import { SearchGPTMessage } from "../../../../components/BrieChatMenu/GPTConvoTypes";
import { searchCommand } from "./searchCommand";
import { Prefill } from "../../../../types/GlobalInterfaces";
import { createRecordCommand } from "./createRecordCommand";
import { sortCommand } from "./sortCommand";
import { navigationCommand } from "./navigationCommand";

export function handleBrieCommands({
  message,
  setQuery,
  navigate,
  setSearch,
  prefills,
  setCreateRecord,
  setPrefill,
}: {
  message: SearchGPTMessage | undefined;
  setQuery: any;
  navigate: NavigateFunction;
  setSearch: SetURLSearchParams;
  prefills: Prefill[];
  setCreateRecord: ((b: boolean) => void) | undefined;
  setPrefill: ((p: Prefill | null) => void) | undefined;
}) {
  const type = message?.Type;

  if (
    !message ||
    [
      "Chat",
      "User",
      "General Question",
      "Platform Question",
      "General Request",
    ].includes(message?.Type)
  )
    return;

  if (type === "Search") {
    searchCommand({ message, setQuery, navigate });
  }

  if (type === "Sort") {
    sortCommand({ message, setQuery, navigate });
  }

  if (type === "Create Record") {
    createRecordCommand({
      message,
      navigate,
      prefills,
      setCreateRecord,
      setPrefill,
    });
  }

  if (type === "Navigate") {
    navigationCommand({
      message,
      navigate,
      setSearch,
    });
  }

  return;
}
